import { render } from "./FormPrice.vue?vue&type=template&id=10fa2194"
import script from "./FormPrice.vue?vue&type=script&lang=js"
export * from "./FormPrice.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__